import { AppDispatch } from '@typings/redux';
import { FullScreenLoader } from 'components/shared/loaders/FullScreenLoader/FullScreenLoader';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { checkAuth } from 'store/auth/auth.action';
import { ROUTE_AUTH } from 'config/routes';
import queryString from 'query-string';

export const SessionRestore: FC<{ children?: ReactNode }> = ({ children }) => {
  const [isResolved, setResolved] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  useEffect(() => {
    if (!isResolved) {
      // Check if there's an auth code in the URL (indicating ongoing authentication)
      const queryParams = queryString.parse(location.search);
      const hasAuthCode = !!queryParams.code;

      // Don't check auth if we're on any auth-related page, if there's an auth code, or if we're on public routes
      // This prevents calling /me before HTTP-only cookies are set from /auth
      const isPublicRoute = /^\/questionnaires\/[^/]+\/[^/]+$/.test(location.pathname);
      const isAuthRoute = location.pathname.startsWith(ROUTE_AUTH);

      if (!isAuthRoute && !hasAuthCode && !isPublicRoute) {
        dispatch(checkAuth());
      }
      setResolved(true);
    }
  }, [dispatch, isResolved, location.pathname, location.search]);

  if (!isResolved) {
    return <FullScreenLoader />;
  }

  return <>{children}</>;
};
